export default "__VITE_ASSET__CmawTuCU__"